import React, { useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import IconButton from "@material-ui/core/IconButton";
import BeforeIcon from '@material-ui/icons/NavigateBeforeRounded';
import Box from "@material-ui/core/Box";
import NextIcon from '@material-ui/icons/NavigateNextRounded';
import { Document, Page, pdfjs } from "react-pdf";
import "assets/css/pdf.css";

const useStyles = makeStyles((theme) => ({
  root: {
    alignContent:"center",
    width: 'fit-content',
    flexDirection: "row",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.secondary,
    '& svg': {
      margin: theme.spacing(1),
    },
    '& hr': {
      margin: theme.spacing(0.5, 0.5),
    },
  },
}));



export default function SinglePage({pdf}) {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1); //setting 1 to show fisrt page
  const classes = useStyles();


    /*To Prevent right click on screen*/
    document.addEventListener("contextmenu", (event) => {
        event.preventDefault();
      });

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPageNumber(1);
  }

  function changePage(offset) {
    setPageNumber(prevPageNumber => prevPageNumber + offset);
  }

  function previousPage() {
    changePage(-1);
  }

  function nextPage() {
    changePage(1,2);
  }


  return (
    <div container alignitems="center">
      <Document
        file={ pdf }
        //options={{ workerSrc: "/pdf.worker.js" }}
        onLoadSuccess={onDocumentLoadSuccess}>
        <Page pageNumber={pageNumber}/>
      </Document>
      <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
          <IconButton color="primary"
              aria-label="before page"
              component="span" 
              disabled={pageNumber <= 1} 
              onClick={previousPage}>
              <BeforeIcon />
          </IconButton>
          <h4>
              Página {pageNumber || (numPages ? 1 : "--")} de {numPages || "--"}
          </h4>
          <IconButton color="primary" 
            aria-label="next page" 
            component="span" 
            disabled={pageNumber >= numPages}
            onClick={nextPage}>
            <NextIcon />
          </IconButton>
      </Box>
      </div>
  );
}

SinglePage.propTypes = {
  pdf: PropTypes.object.isRequired
}